// import { JobProfileTableStyle } from "./JobProfileTableStyle"

import { JobProfileTableStyle } from "../job-profile-table/JobProfileTableStyle"

export function JobProfileToolsTable({ data, onDelete, onEdit, options, actions }) {
	const items = [
		{
			name: "description",
			label: "Nombre",
			props: {},
		},
		// {
		// 	name: "tipo",
		// 	label: "Tipo",
		// 	props: { align: "right" },
		// },
		{
			name: "departamento_name",
			label: "Departamento",
			props: { align: "right" },
		},
	]

	return <JobProfileTableStyle {...{ items, data, onDelete, onEdit, options, actions }} />
}
